module.exports = __webpack_public_path__ + "img/sp_text.dfe3b52f.svg";